import React, { Fragment } from "react";
import { useSearchParams } from "react-router-dom";
import Header from "../../components/Header/Header";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import ApplyForm from "./ApplyForm";

// Job Details Data
const jobDetails: { [key: string]: any } = {
    "full-stack-developer": {
        title: "Full Stack Developer",
        type: "Full-time",
        location: "Remote, India",
        description: "We're looking for a Full Stack Developer to join our team. You'll be working on cutting-edge projects using modern technologies.",
        requirements: [
            "Proficient in programming languages such as JavaScript, Java, or Python",
            "Knowledge of database systems SQL/NOSQL",
            "Ability to work in a team and collaborate effectively",
            "Understanding of front-end technologies such as HTML, CSS, JavaScript, and React",
            "Strong knowledge in back-end frameworks such as Laravel, Spring Boot, and Django",
            "Strong problem-solving skills and attention to detail",
            "Excellent communication and organizational skills",
            "Currently pursuing/completed a degree/Masters in Computer Science or a related field"
        ],
        skills: ["React", "Java", "Python", "Spring Boot", "Laravel", "Git"],
        isActive: false
    },
    "ui-ux-designer": {
        title: "UI / UX Designer",
        type: "Full-time",
        location: "Remote, India",
        description: "We're seeking a talented UI/UX Designer to create amazing user experiences.",
        requirements: [
            "Proven experience as a UI/UX Designer or similar role with a strong portfolio showcasing design projects",
            "Proficiency in design and prototyping tools such as Sketch, Figma, Adobe XD, or similar",
            "Strong understanding of user-centered design principles and best practices",
            "Ability to work in a fast-paced, collaborative environment",
            "Strong problem-solving skills and attention to detail",
            "Excellent communication and organizational skills",
            "Currently pursuing/completed a degree/Masters in Computer Science or a related field"
        ],
        skills: ["React", "Figma", "User Experience", "Adobe XD", "Bootstrap"],
        isActive: false
    },
    "frontend-developer": {
        title: "Front-end Developer",
        type: "Full-time",
        location: "Remote, India",
        description: "Join our team as a Front-end Developer to build beautiful, responsive web applications.",
        requirements: [
            "Understanding of front-end technologies such as HTML, CSS, and JavaScript",
            "Develop front-end components and features using React.js or Angular.js",
            "Contribute to the continuous improvement of our development processes and best practices",
            "Experience with web development frameworks React or Angular",
            "Collaborate with design and backend teams to implement user interfaces and application logic",
            "Optimize web applications for maximum speed and scalability",
            "Participate in code reviews and provide constructive feedback to team members",
            "Stay up-to-date with emerging technologies and industry trends",
            "Currently pursuing/completed a degree/Masters in Computer Science or a related field"
        ],
        skills: ["Responsive web design", "React", "Angular", "Figma", "Bootstrap"],
        isActive: false
    },
    "mern-mean-stack-developer": {
        title: "MERN/MEAN Stack Developer",
        type: "Full-time",
        location: "Remote, India",
        description: "We're looking for a MERN/MEAN Stack Developer to build full-stack web applications.",
        requirements: [
            "Develop, and deploy high-quality web applications using the MEARN (MongoDB, Express.js, Angular, React, Node.js) stack",
            "Create and maintain server-side logic and integrate with front-end components",
            "Develop and manage well-functioning databases and applications",
            "Troubleshoot and debug applications to optimize performance",
            "Understanding of front-end technologies such as HTML, CSS, and JavaScript",
            "Participate in the full software development lifecycle (SDLC) including requirements gathering, analysis, design, development, testing, deployment, and maintenance",
            "Experience with NoSQL databases, particularly MongoDB",
            "Currently pursuing/completed a degree/Masters in Computer Science or a related field"
        ],
        skills: ["React", "Node", "Mongo", "Express", "Bootstrap"],
        isActive: false
    },
    "business-analyst": {
        title: "Business Analyst",
        type: "Full-time",
        location: "Remote, India",
        description: "Join us as a Business Analyst to help drive data-driven decisions and business improvements.",
        requirements: [
            "Conduct data analysis to identify trends, patterns, and opportunities for improvement",
            "Collaborate with stakeholders to understand business requirements and translate them into actionable insights",
            "Assist in the preparation of reports, presentations, and documentation to communicate findings to various audiences",
            "Excellent communication and teamwork abilities",
            "Bachelor's degree in Finance, Business Administration, or related field"
        ],
        skills: ["Business Analysis", "Business Process Mapping", "Regulatory Compliance", "Wealth Management Services"],
        isActive: false
    },
    "digital-marketing": {
        title: "Digital Marketing",
        type: "Full-time",
        location: "Remote, India",
        description: "We're looking for a Digital Marketing specialist to grow our online presence and brand awareness.",
        requirements: [
            "Develop and implement digital marketing strategies to increase brand awareness and engagement",
            "Create compelling and relevant content for various digital channels to attract and retain customers",
            "Skilled in flex and poster designing",
            "Monitor and analyze the performance of digital marketing campaigns to make data-driven decisions for future initiatives",
            "Collaborate with the marketing team to brainstorm new ideas and innovative approaches to reach our marketing goals",
            "Stay up-to-date with the latest trends and best practices in digital marketing to ensure the company remains competitive in the industry"
        ],
        skills: ["Marketing Analytics", "Competitive Analysis", "Social Media Marketing", "Digital Marketing"],
        isActive: false
    }
};

const CareerDetails: React.FC = () => {
    const [searchParams] = useSearchParams();
    const jobSlug = searchParams.get("job") || "full-stack-developer";
    console.log(`🔍 CareerDetails: Extracting job from URL: ${jobSlug}`);
    const job = jobDetails[jobSlug] || jobDetails["full-stack-developer"];

    if (job && job.isActive === false) {
        return (
            <Fragment>
                <div className='about-page inner-page'>
                    <div className="body_wrap o-clip">
                        <Header />
                        <main>
                            <PageTitle pageTitle="Position Closed" pagesub="Position Closed" parentPage="Careers" parentLink="/career" />
                            <section className="career-details">
                                <div className="container">
                                    <div className="cp-details-wrap text-center py-5">
                                        <h2 className="mb-30">This position is currently closed.</h2>
                                        <p>Please check back later or explore other open positions on our careers page.</p>
                                    </div>
                                </div>
                            </section>
                        </main>
                        <Footer />
                        <Scrollbar />
                    </div>
                </div>
            </Fragment>
        );
    }

    return (
        <Fragment>
            <div className='about-page inner-page'>
                <div className="body_wrap o-clip">
                    <Header />
                    <main>
                        <PageTitle pageTitle={job.title} pagesub={job.title} parentPage="Careers" parentLink="/career" />
                        <section className="career-details">
                            <div className="container">
                                <div className="cp-details-wrap">

                                    {/* Job Info */}
                                    <div className="cp-manager_info">
                                        <h2 className="details-content-title mb-30">
                                            {job.title} - ({job.type})
                                        </h2>

                                        <ul className="xb-details-content list-unstyled mb-35">
                                            <li><span>Department :</span> {job.title}</li>
                                            <li><span>Job Type :</span> {job.type}</li>
                                            <li><span>Location :</span> {job.location}</li>
                                            <li><span>Working Mode :</span> Remote</li>
                                        </ul>

                                        <p className="mb-30">
                                            {job.description}
                                        </p>
                                    </div>

                                    {/* Requirements */}
                                    <div className="xb-details-item">
                                        <h3 className="details-title mt-70">Requirements</h3>
                                        <ul className="content-list mt-25">
                                            {job.requirements.map((req: string, index: number) => (
                                                <li key={index}>{req}</li>
                                            ))}
                                        </ul>
                                    </div>

                                    {/* Skills */}
                                    <div className="xb-details-item">
                                        <h3 className="details-title mt-70">Skills</h3>
                                        <div className="mt-25" style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
                                            {job.skills.map((skill: string, index: number) => (
                                                <span key={index} style={{
                                                    background: "rgba(252, 144, 56, 0.1)",
                                                    border: "1px solid rgba(252, 144, 56, 0.3)",
                                                    borderRadius: "20px",
                                                    padding: "8px 16px",
                                                    fontSize: "14px",
                                                    color: "#fc9038"
                                                }}>
                                                    {skill}
                                                </span>
                                            ))}
                                        </div>
                                    </div>

                                    {/* Benefits */}
                                    <div className="xb-details-item">
                                        <h3 className="details-title mt-70">Why Join AquarLabs?</h3>
                                        <ul className="content-list mt-25">
                                            <li>Work on cutting-edge projects with modern technologies</li>
                                            <li>Flexible remote work environment</li>
                                            <li>Collaborative and supportive team culture</li>
                                            <li>Opportunity for growth and learning</li>
                                            <li>Competitive compensation</li>
                                        </ul>
                                    </div>

                                    {/* ApplyForm */}
                                    <ApplyForm position={job.title} />

                                </div>
                            </div>
                        </section>
                    </main>
                    <Footer />
                    <Scrollbar />
                </div>
            </div>
        </Fragment>
    );
};

export default CareerDetails;
